angular
  .module('ordersModifyGoods')
  .component('ordersModifyGoods', {
    template: require('./orders-modify-goods.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function ordersModifyGoods($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'all';
        this.commonFunc = $rootScope.commonFunc;
        this.modifyed = false;

        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $scope.loginMember = AuthService.loginMember();
        const { orderNo } = $routeParams;
        $resource(`${APIURL}/admin/orders/:orderNo/modify/goodsoptions`, { orderNo }).get().$promise
          .then((data) => {
            this.oldOrder = data.order;
            this.goods = data.goods;
            console.log(data);
            this.payload = { newGoodsId: data.order.goods.GOODS_ID };
            this.options = data.options.map((option) => {
              option.checked = this.oldOrder.options.filter(selectedOption => selectedOption.ID === option.ID).length > 0;
              return option;
            });
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

        this.newGoodsIdChanged = () => {
          const newGood = this.goods.filter(good => good.GOODS_ID === this.payload.newGoodsId)[0];
          $resource(`${APIURL}/wash/goods/${newGood.ID}/options`, {}, { get: {
            method: 'GET',
            headers: {
              'IW-App-Version': '5.0.0',
            },
          } }).get({ COUNTRY_CODE: this.oldOrder.COUNTRY_CODE }, (data) => {
            this.options = data.options;
          }, (err) => {
            this.options = [];
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        const getModifyRequestPayload = () => {
          const selectedOptions = this.options.filter(option => option.checked);
          if (selectedOptions.length < 1) {
            return { goodsId: this.payload.newGoodsId,
              refundOptionType: this.payload.refundOptionType,
              refundBankAccountHolder: this.payload.refundBankAccountHolder,
              refundBankname: this.payload.refundBankname,
              refundAccountNumber: this.payload.refundAccountNumber,
            };
          }
          const optionCodes = selectedOptions.map(option => option.ID).join(',');
          const optionNames = selectedOptions.map(option => option.OPTION_NAME).join(',');
          const optionQuantities = selectedOptions.map(() => 1).join(',');
          return { goodsId: this.payload.newGoodsId,
            optionCodes,
            optionNames,
            optionQuantities,
            refundOptionType: this.payload.refundOptionType,
            refundBankAccountHolder: this.payload.refundBankAccountHolder,
            refundBankname: this.payload.refundBankname,
            refundAccountNumber: this.payload.refundAccountNumber,
          };
        };

        this.tryModifyGoodsAndOptions = () => {
          $resource(`${APIURL}/admin/orders/:orderNo/modify/goodsoptions/try`, { orderNo })
            .save(getModifyRequestPayload()).$promise
            .then((data) => {
              console.log(data);
              const { originalOrder, order, diffTotalPrice, refundOptions } = data;
              this.oldOrder = originalOrder;
              this.newOrder = order;
              this.diffTotalPrice = diffTotalPrice;
              this.refundOptions = refundOptions;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.doModifyGoodsAndOptions = () => {
          if (!confirm($translate.instant('수정하시겠습니까?"'))) {
            return;
          }
          $resource(`${APIURL}/admin/orders/:orderNo/modify/goodsoptions/done`, { orderNo })
            .save(getModifyRequestPayload()).$promise
            .then((data) => {
              const { originalOrder, order, priceInformation, cautionTitle, cautionTxt } = data;
              this.oldOrder = originalOrder;
              this.newOrder = order;
              this.priceInformation = priceInformation;
              this.cautionTitle = cautionTitle;
              this.cautionTxt = cautionTxt;
              this.modified = true;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-modify-goods/orders-modify-goods.component.js